import { render, staticRenderFns } from "./TmzSearchKmg.vue?vue&type=template&id=3ddae820&scoped=true&"
import script from "./TmzSearchKmg.vue?vue&type=script&lang=js&"
export * from "./TmzSearchKmg.vue?vue&type=script&lang=js&"
import style0 from "./TmzSearchKmg.vue?vue&type=style&index=0&id=3ddae820&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ddae820",
  null
  
)

export default component.exports